import React, { Component } from 'react'
import Localshop from './project/Localshop'

export default class Fproject_page extends Component {
    constructor(props){
        super(props)
        this.state = {
            data: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    tilte = () => {
        const pathname = this.props.location.pathname;
        const index = pathname.lastIndexOf('/');
        const fileName = pathname.substring(index + 1);
        return fileName
    }

    fun =() => {
        const pathname = this.props.location.pathname;
        const index = pathname.lastIndexOf('/');
        const fileName = pathname.substring(index + 1);
        if(fileName === "Local shop"){
            return <Localshop />
        }
        else if(fileName === ""){
            return "404"
        }
    }

    render() {
        return (
            <div className="container-fluid px-sm-5 px-4 pt-5">
                <div className="row"  id="heading">
                    <p className="pt-4">
                        <span className="text-muted" style={{ letterSpacing: 2 }}>
                          CASE STUDIES
                        </span>
                        <br />
                        <span className="display-4 fopri text-uppercase">{this.tilte()}</span>
                    </p>
                </div>
                {this.fun()}
            </div>
    )
}
}